import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {
  Card,
  CardContent,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';
import { shortenDate, shortenTime } from '../../../MeetupList/components/MeetupsTable/MeetupsTable';

const PREFIX = 'AccountsTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },
}));

const AccountsTable = props => {
  const {
    className,
    accounts,
    handleDelete,
    handleLogin,
    totalCount,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    ...rest
  } = props;

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Название</TableCell>
                <TableCell>Email владельца</TableCell>
                <TableCell style={{ width: '200px' }}>Дата регистрации</TableCell>
                <TableCell style={{ width: '200px' }}>Последняя активность</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accounts.map(account => (
                <TableRow hover key={account.owner.email}>
                  <TableCell>
                    <RouterLink to={'/sa/account/id/' + account.accountId}>{account.name}</RouterLink> [
                    {account.accountId}]<br />
                    <span style={{ color: 'gray' }}>{account.internalComment}</span>
                  </TableCell>
                  <TableCell>{account.owner.email}</TableCell>
                  <TableCell style={{ width: '200px' }}>{shortenDate(account.creationDate)}</TableCell>
                  <TableCell style={{ width: '200px' }}>
                    {shortenTime(account.lastActiveDate)} [{account.actionsCount}]
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', width: '100px' }}>
                    <DropDownMenu>
                      <MenuItem
                        onClick={() => {
                          handleLogin(account.accountId);
                        }}
                      >
                        <ListItemText primary='Войти в аккаунт' />
                      </MenuItem>
                      <MenuItem>
                        <RouterLink to={'/sa/account/id/' + account.accountId + '/payment'}>
                          <ListItemText primary='Изменить баланс' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem>
                        <RouterLink to={'/sa/account/id/' + account.accountId + '/tariff'}>
                          <ListItemText primary='Сменить тариф' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem>
                        <RouterLink to={'/sa/account/id/' + account.accountId + '/pack'}>
                          <ListItemText primary='Применить пакет' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem>
                        <RouterLink to={'/sa/account/id/' + account.accountId}>
                          <ListItemText primary='Редактировать' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDelete(account.accountId);
                        }}
                      >
                        <ListItemText primary='Удалить аккаунт' />
                      </MenuItem>
                    </DropDownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component='div'
          count={totalCount || 0}
          rowsPerPage={rowsPerPage || 10}
          page={page || 0}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </CardContent>
    </StyledCard>
  );
};

AccountsTable.propTypes = {
  className: PropTypes.string,
  accounts: PropTypes.array.isRequired,
  totalCount: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
};

export default AccountsTable;
